import { Box, Flex, Section } from "@radix-ui/themes";
import { Navbar } from "../components/Navbar";
import { Countdown } from "../components/Countdown.tsx";
import ArticleContainer from "../components/ArticleContainer.tsx";

function Introduction() {
  return (
    <Box>
      <Navbar />
      <Countdown />
      <Flex justify={"center"}>
        <Box width={"1000px"}>
          <Section>
            <ArticleContainer>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>This game has a theme.</Box>
              </Box>
              <Box
                style={{
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>
                  AI has advanced rapidly and the pace is growing at a rate that
                  multiplies energy and computing availability times
                  advancements in training and assessment efficiency. Though the
                  events reported and described in this game are fiction, it is
                  chilling to consider how reality could come to resemble the
                  fiction. Welcome to REALI7Y OVERRUN.
                </Box>
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>The state of the board, current.</Box>
              </Box>
              <Box
                style={{
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>
                  DefCon is cancelled! No it actually isn't -- but did you know
                  that it almost was? A series of gaffes, mistaken
                  communications, sudden changes of heart from remote
                  administrators and finally the unexpected and unprecedented
                  cancellation of the DefCon venue mere months before the 'con
                  was supposed to begin all combine to paint a picture of an
                  event that very nearly really and truly was cancelled. But we
                  perservered. And unravelling this, and many other questions,
                  is the mission of this game. If we had an adversary that
                  wanted to disrupt our data, our knowledge, our digital
                  connection to each other... where would it choose to attack
                  us? Perhaps at the biggest gathering of those who could defeat
                  it?
                </Box>
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginBottom: "10px",
                  marginTop: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                {" "}
                We{" "}
                <span
                  style={{
                    textDecoration: "line-through",
                    color:
                      "var(--ro-text)" /* Highlight color to match new color scheme */,
                  }}
                >
                  can't
                </span>{" "}
                won't tell you much.
              </Box>
              <Box
                style={{
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>
                  Once you create a character and enter the game, you'll notice
                  a few things. (1) TK! (2) TK! (3) The game has a messaging
                  function that is critically important as it is the only
                  official way for players to interact. (4) Explore: the game's
                  win condition will be revealed only by exploring in the game.
                  (5) DefCon is in the game: there are real world puzzles in the
                  game that will require you to do things at DefCon. If you're
                  remote, team up with others on site to get those things done.
                </Box>
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>Trust is a delicate thing.</Box>
              </Box>
              <Box
                style={{
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>
                  One of the most interesting aspects of trust that we know of
                  is that it is founded on the predictive veracity of someone
                  who is to be trusted -- in short, they do what they say they
                  will do, and they are who they say they are. Events confirming
                  this build trust; those that do not, destroy it. Trust cannot
                  be taken lightly in this game.
                </Box>
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>
                  If someone tells you that you should follow the rules, you
                  probably shouldn't follow the rules.
                </Box>
              </Box>
              <Box
                style={{
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>Not like we're going to tell you the rules, though.</Box>
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  fontSize: "20px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>This is the first iteration of the game.</Box>
              </Box>
              <Box
                style={{
                  color:
                    "var(--ro-text)" /* Highlight color to match new color scheme */,
                }}
              >
                <Box>
                  This is the first time we've run this game and the expectation
                  is that this storyline will continue in following years as
                  things unfold.
                </Box>
              </Box>
            </ArticleContainer>
          </Section>
        </Box>
      </Flex>
    </Box>
  );
}

export default Introduction;
